module.exports = __webpack_public_path__ + "img/b9ed2d03ac2ceadfd3a57623c71b1d2b.png";